import connect from 'react-redux/es/connect/connect';
import PasswordChangePage from '../../components/pages/PasswordChangePage';
import { setLoggedInUser } from '../../actions/user';

const mapDispatchToProps = dispatch => ({
    setLoggedInUser: user => {
        dispatch(setLoggedInUser(user));
    }
});

export default connect(() => ({}), mapDispatchToProps)(PasswordChangePage);
